module.exports = __webpack_public_path__ + "static/img/img-5.e316561.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-5.png
// module id = vTID
// module chunks = 0